import { useEffect, useState } from 'react';

import { useStore } from '../zustand/stores';

export const useWixRecorder = () => {
  const sessionBI = useStore((state) => state.sessionSlice.sessionBI);
  const [isLoaded, setIsLoaded] = useState(false);

  const isWixRecorderLoaded = () => typeof window !== 'undefined' && window.wixRecorder;

  useEffect(() => {
    const interval = setInterval(() => {
      if (isWixRecorderLoaded()) {
        setIsLoaded(true);
        clearInterval(interval);
      }
    }, 300);

    const timeout = setTimeout(() => {
      clearInterval(interval);
      console.warn('wix-recorder script failed to load within 2 minutes');
    }, 120000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  useEffect(() => {
    const selfServiceSessionId = sessionBI?.selfServiceSessionId;
    if (!selfServiceSessionId || !isLoaded) {
      return;
    }

    window.wixRecorder.addLabel('kb-client-nextjs');
    window.wixRecorder.addCustomAttribute('sessionId', selfServiceSessionId);
  }, [sessionBI, isLoaded]);
};
